var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeoGaugeSkeleton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 264 132",
    preserveAspectRatio: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 112C24 55.67 72.35 18 132 18C191.65 18 240 55.67 240 112",
    fill: "none",
    stroke: "#D8DADD",
    strokeLinecap: "round",
    strokeWidth: 22,
    pathLength: 100
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeoGaugeSkeleton);
export default __webpack_public_path__ + "static/media/seo-gauge-skeleton.fb7045c5420346c58939a54d04210135.svg";
export { ForwardRef as ReactComponent };